import { type RPPCore } from '@retailer-platform/dashboard/app'
import EnterpriseSolutionsDomain from '@retailer-platform/domain-enterprise-solutions/domainDefinition'
import CredentialsManagementDomain from '@retailer-platform/domain-credentials-management/domainDefinition'
import CashflowDomain from '@retailer-platform/domain-cashflow/domainDefinition'
import AggregateStorePerformanceDomain from '@retailer-platform/domain-aggregate-store-performance/domainDefinition'
import DataIngestionDomain from '@retailer-platform/domain-data-ingestion/domainDefinition'
import CaperDomain from '@retailer-platform/domain-caper/domainDefinition'
import ShiftsDomain from '@retailer-platform/domain-shifts/domainDefinition'
import PartnerOnboardingDomain from '@retailer-platform/domain-partner-onboarding/domainDefinition'
import ConnectOrdersDomain from '@retailer-platform/domain-connect-orders/domainDefinition'
import LegacyOrdersDomain from '@retailer-platform/domain-legacy-orders/domainDefinition'
import EversightDomain from '@retailer-platform/domain-eversight/domainDefinition'
import OrdersOperationalDashboardDomain from '@retailer-platform/domain-orders-operational-dashboard/domainDefinition'
import CatalogAdminDomain from '@retailer-platform/domain-catalog-admin/domainDefinition'
import PartnerPickDevicesDomain from '@retailer-platform/domain-partner-pick-devices/domainDefinition'
import ConnectedStoresDomain from '@retailer-platform/domain-connected-stores/domainDefinition'
import ProductsDomain from '@retailer-platform/domain-products/domainDefinition'
import SiteManagementDomain from '@retailer-platform/domain-site-management/domainDefinition'

export const registerDomains = (app: RPPCore) => {
  app.attachDomain(EnterpriseSolutionsDomain)
  app.attachDomain(CredentialsManagementDomain)
  app.attachDomain(CashflowDomain)
  app.attachDomain(AggregateStorePerformanceDomain)
  app.attachDomain(DataIngestionDomain)
  app.attachDomain(CaperDomain)
  app.attachDomain(ShiftsDomain)
  app.attachDomain(PartnerOnboardingDomain)
  app.attachDomain(ConnectOrdersDomain)
  app.attachDomain(LegacyOrdersDomain)
  app.attachDomain(EversightDomain)
  app.attachDomain(OrdersOperationalDashboardDomain)
  app.attachDomain(CatalogAdminDomain)
  app.attachDomain(PartnerPickDevicesDomain)
  app.attachDomain(ConnectedStoresDomain)
  app.attachDomain(ProductsDomain)
  app.attachDomain(SiteManagementDomain)
}
